import profilePage from '../pages/profile/ProfilePage.vue'
import dashboardPage from '../pages/dashboard/DashboardPage.vue'
import loginPage from '../pages/login/LoginPage.vue'
import transactionsPage from '../pages/transactions/TransactionsPage.vue'
import settlementsPage from '../pages/settlements/SettlementsPage.vue'
import notFoundPage from '@/pages/not-found/NotFound.vue'
import { DOMAIN_TITLE } from '../.env'

export const routes = [
  { 
    path: '/', redirect: '/finances/payslips' 
  },
  { 
    path: '/profile',
    name: 'profilePage',
    component: profilePage,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | profile` },
  },
  {
    path: '/finances',
    name: 'finances',
    meta: {isAuth: true, checkPermitions: true, layout: 'main', title: `${DOMAIN_TITLE} | finances` },
    children: [
      {
        path: 'payslips',
        name: 'payslips',               
        children: [
          {
            path: '',
            name: 'payslipsPage',
            component: () => import('../pages/payslips/PayslipPage.vue'),
            props: { side: "t2", setDefaultParam: true },             
            key: 't1'
          },
        ]
      },    
    ]
  },
  { 
    path: '/dashboard',
    name: 'dashboardsPage',
    component: dashboardPage,
    meta: { isAuth: true, checkPermitions: true, title: `${DOMAIN_TITLE} | dashboard` },
  },   
  {
    path: '/transactions',
    name: 'transactionsPage',
    component: transactionsPage,
    meta: { isAuth: true, checkPermitions: true, title: `${DOMAIN_TITLE} | transactions` },
  },
  {
    path: '/settlements',
    name: 'settlementsPage',
    component: settlementsPage,
    meta: { isAuth: true, checkPermitions: true, title: `${DOMAIN_TITLE} | settlements` },
  },
  {
    path: '/balances',
    name: 'balancesPage',
    component: () => import('../pages/settlements/BalancesPage.vue'),
    meta: { isAuth: true, checkPermitions: true, title: `${DOMAIN_TITLE} | balances` },
  },
  {
    path: '/login/authorization-code/:code',
    name: 'LoginWithCode',
    component: () => import('@/pages/LoginWithCode.vue'),
    meta: { layout: 'empty', title: `${DOMAIN_TITLE} | login` },
    props: (route) => ({
      code: route.params.code
    })
  },
  {
    path: '/login',
    name: 'login',
    component: loginPage,
    meta: { layout: 'empty', title: `${DOMAIN_TITLE} | login` },
    beforeEnter: (to, from, next) => {
      if (to.query.code) {
        // Если есть параметр code, перенаправляем на маршрут с параметром
        next({ path: '/login/authorization-code/' + to.query.code })
      } else {
        next()
      }
    }    
  },
  {
    path: '/not-found',    
    component: notFoundPage,
    meta: { layout: 'empty', title: `${DOMAIN_TITLE} | not found` }
  },
  {
    path: '/:random',
    component: notFoundPage,
    meta: { layout: 'empty', title: `${DOMAIN_TITLE} | not found` }
  },

]
